import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createFeature,
  getFeature,
  getFeatures,
  editFeature,
  deleteFeature,
} from "api/featureApi"

export const FEATURE_QUERY_KEY = "features"

export const useFeatures = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [FEATURE_QUERY_KEY, params],
    queryFn: () => getFeatures(params),
    keepPreviousData: true,
    enabled,
  })
}

export const useFeature = id => {
  return useQuery({
    queryKey: [FEATURE_QUERY_KEY, id],
    queryFn: () => getFeature(id),
    enabled: !!id,
  })
}

export const useCreateFeature = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createFeature,
    onSuccess: data => {
      if (data?.success) queryClient.invalidateQueries([FEATURE_QUERY_KEY])
    },
  })
}

export const useEditFeature = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: editFeature,
    onSuccess: data => {
      if (data?.success) queryClient.invalidateQueries([FEATURE_QUERY_KEY])
    },
  })
}

export const useDeleteFeature = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteFeature,
    onSuccess: data => {
      if (data?.success) queryClient.invalidateQueries([FEATURE_QUERY_KEY])
    },
  })
}
